import { jsx as _jsx } from "react/jsx-runtime";
import { COBStep } from '../../../ClientOnboarding.utils';
import { AdditionalTerms } from './AdditionalTerms/AdditionalTerms';
import { Introduction } from './Introduction/Introduction';
import { IntroVideo } from './IntroVideoStep/IntroVideo';
import { PaymentMethod } from './PaymentMethod/PaymentMethod';
import { ReviewServices } from './ReviewServices';
import { SelectAPackage } from './SelectAPackage';
import { SignAndApprove } from './SignAndApprove/SignAndApprove';
import { TermsOfService } from './TermsOfService/TermsOfService';
export const StepContent = (param)=>{
    let { currentStep } = param;
    switch(currentStep){
        case COBStep.introduction:
            return /*#__PURE__*/ _jsx(Introduction, {});
        case COBStep.introVideo:
            return /*#__PURE__*/ _jsx(IntroVideo, {});
        case COBStep.selectAPackage:
            return /*#__PURE__*/ _jsx(SelectAPackage, {});
        case COBStep.reviewServices:
            return /*#__PURE__*/ _jsx(ReviewServices, {});
        case COBStep.termsOfService1:
        case COBStep.termsOfService2:
        case COBStep.termsOfService3:
        case COBStep.termsOfService4:
            return /*#__PURE__*/ _jsx(TermsOfService, {
                currentStep: currentStep
            });
        case COBStep.approveTerms:
            return /*#__PURE__*/ _jsx(AdditionalTerms, {});
        case COBStep.paymentMethod:
            return /*#__PURE__*/ _jsx(PaymentMethod, {});
        case COBStep.signAndApprove:
            return /*#__PURE__*/ _jsx(SignAndApprove, {});
        default:
            return null;
    }
};
